import React, { useContext, useCallback } from 'react';
import { ICategoryContext, CategoryContext } from '../categoryState/categoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalSelectCustomer } from 'components/ModalWindows/ModalSelectCustomer';
import { ModalAssignCategoryToRestaurants } from 'components/ModalWindows/ModalAssignCategoryToRestaurants';

export const ModalWindows: React.FC = () => {
	const {
		refetchData,
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setIDCustomer,
		toggleRememberMyChoice,
		rememberMyChoice,
		typeOfModalWindow,
		IDForAssignRestaurants,
		IDSelectedCustomer,
		isInitializedSelectCustomerModal,
	} = useContext<ICategoryContext>(CategoryContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModal = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingCategory');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !IDSelectedCustomer}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteCategory"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteCategorySuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingCategory"
				/>
			)}
			{typeOfModalWindow === 'errorUpdatingCategory' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingCategory"
				/>
			)}
			{!IDSelectedCustomer && isInitializedSelectCustomerModal && (
				<ModalSelectCustomer
					setIDCustomer={setIDCustomer}
					toggleRememberMyChoice={toggleRememberMyChoice}
					rememberMyChoice={rememberMyChoice}
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && IDForAssignRestaurants && (
				<ModalAssignCategoryToRestaurants
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseAssignRestaurantsModal}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					categoryId={IDForAssignRestaurants}
				/>
			)}
		</ModalWrapper>
	);
};
